// /**
//  * Three Column Carousel
//  */

import 'owl.carousel/dist/owl.carousel.min.js';

import $ from 'jquery';

const statsCarousel = {
  prevIcon: '<span class="carousel-control-prev-icon" aria-hidden="true"></span>',
  nextIcon: '<span class="carousel-control-next-icon" aria-hidden="true"></span>',
  initStatsCarousel: () => {
    // Add Resize listener to enable/disable carousel
    $(window).on('resize', function () {
      if (
        $(window).width() < 961 &&
        $('.statistic-carousel-wrapper').find('>:first-child').hasClass('off')
      ) {
        statsCarousel.startCarousel();
        $('.statistic-carousel-wrapper').find('>:first-child').removeClass('off');
      } else if (
        $(window).width() >= 961 &&
        $('.statistic-carousel-wrapper').find('>:first-child').hasClass('on')
      ) {
        if ($('.statistic-carousel-wrapper').find('>:first-child').hasClass('on')) {
          $('.statistic-carousel-wrapper').each(function () {
            // Disable/destroy owl-carousel and updated classes
            $(this).find('>:first-child').trigger('destroy.owl.carousel');
            $(this).find('>:first-child').removeClass('on');
            $(this).find('>:first-child').addClass('off');

            // Re-add icon elements lost in destruction of owl-carousel
            if (
              $(this).find('.carousel-control-prev-icon').length === 0 &&
              $(this).find('.carousel-control-next-icon').length === 0
            ) {
              $(this).find('.carousel-control-prev').prepend(statsCarousel.prevIcon);
              $(this).find('.carousel-control-next').prepend(statsCarousel.nextIcon);
            }
          });
        }
      }
    });

    // If screen is md or small start owl-carousel
    $('.statistic-carousel-wrapper').each(function () {
      if ($(window).width() < 961) {
        statsCarousel.startCarousel();
        $(this).find('>:first-child').addClass('on');
        $(this).find('>:first-child').removeClass('off');
      } else {
        $('.statistic-carousel-wrapper').each(function () {
          $(this).find('>:first-child').trigger('destroy.owl.carousel');
          $(this).find('>:first-child').removeClass('on');
          $(this).find('>:first-child').addClass('off');
        });
      }
    });
  },
  startCarousel: () => {
    $('.statistic-carousel-wrapper').each(function () {
      $(this).find('>:first-child').addClass('on');
      $(this)
        .find('>:first-child')
        .owlCarousel({
          smartSpeed: 300,
          direction: 'next',
          slideTransition: 'linear',
          loop: false,
          slideBy: 1,
          dotsEach: 1,
          margin: 0,
          stagePadding: 0,
          nav: true,
          dots: true,
          autoWidth: true,
          lazyload: false,
          items: 6,
          navText: [
            $(this).find('.carousel-control-prev-icon'),
            $(this).find('.carousel-control-next-icon'),
          ],
          onInitialized() {
            $('.statistic-grid-carousel').find('.owl-item').attr('aria-current', 'false');
            $('.statistic-grid-carousel').find('.owl-item.active').attr('aria-current', 'true');
            // Add aria attribute to dots
            $('.statistic-grid-carousel')
              .find('.owl-dot')
              .each(function (index) {
                //Add one to index so it starts from 1
                $(this).attr('aria-label', `slide ${index + 1}`);
              });
            $('.statistic-grid-carousel').attr('tabindex', '0');
            // Add aria attributes to buttons
            $('.statistic-grid-carousel').find('.owl-prev').attr('aria-label', 'previous');
            $('.statistic-grid-carousel').find('.owl-prev').attr('role', 'button');
            $('.statistic-grid-carousel').find('.owl-next').attr('aria-label', 'next');
            $('.statistic-grid-carousel').find('.owl-next').attr('role', 'button');
          },
        });
    });
  },
};

export default statsCarousel;
